import React, { useContext } from 'react'
import {
  Box, Text, Select, IcoMoon, KeyboardArrowDownIcon,
} from '@usap/uicomponents'
import { SearchContext } from '../../common/context/SearchContextProvider'
import seoIDs from '../../../../config/seoIds'
import { GTM } from '../../../helpers'
import { LocalContext } from '../../../helpers/useLocalContext'
import PageTypeIdentifier from '../../../helpers/PageTypeIdentifier'

const sortFlag = 'sort'
const defaultSort = 'best-match'
const itemPerPage = 'itemperpage'
const defaultPageItems = 15
const currentPage = 'currentpage'
const defaultCurrentPage = '1'

export default function Desktop(props) {
  const { toggleItemsPerPage } = props
  const {
    searchState: { products, sortOptions },
  } = useContext(SearchContext)
  const { resultCount: numberOfProducts = 0 } = products
  const { localContext } = useContext(LocalContext)
  const { history } = localContext
  const urlParams = new URLSearchParams(
    __BROWSER__ ? window.location.search : history.location.pathname,
  )

  const sortSelected = urlParams.get(sortFlag) || defaultSort
  const pageItemsCount = Number(urlParams.get(itemPerPage) || defaultPageItems)
  const pageNumber = Number(urlParams.get(currentPage) || defaultCurrentPage)
  const hasMinNumberOfProducts = pageItemsCount > numberOfProducts
  const shownRecords = hasMinNumberOfProducts
    ? numberOfProducts
    : pageItemsCount
  const selectedOption = sortOptions.find(element => element.value === sortSelected) || ''
  const ariaLabel = selectedOption.label ? selectedOption.label : 'Best Match' 
  const { searchResultsTabView } = GTM

  return (
    <Box id="sortByComponent" direction="row" gap="small" align="center">
      <Box id="sortByTextWrapper" width="48%" align="end">
        <Text id="sortByText" size="small" color="dark-2" weight={500}>
          Sort by:
        </Text>
      </Box>

      <Box
        width="210px"
        border={{ color: 'light-3', side: 'all', size: 'xsmall' }}
        round="xsmall"
      >
        <Select
          id={seoIDs.sortByFilter}
          plain
          size="small"
          pad="xsmall"
          icon={() => <IcoMoon icon={KeyboardArrowDownIcon} size="24px" />}
          labelKey="label"
          valueKey="value"
          dropProps={{
            margin: { top: '3px' },
            borderRadius: '4px',
          }}
          value={selectedOption}
          options={sortOptions}
          a11yTitle={ariaLabel}
          // eslint-disable-next-line react/no-children-prop
          children={option => (
            <Box
              id={`option-${option.value.toString().replace(/ /g, '-')}`}
              key={option}
              pad="11px"
            >
              <Text size="small" color="dark-2" weight={500}>
                {option.label}
              </Text>
            </Box>
          )}
          onChange={({ value }) => {
            const categories = `Sort by ${value.label}`

            PageTypeIdentifier.setIdentifier(window?.pageType || null)

            searchResultsTabView({
              searchResultsCount: numberOfProducts,
              categories,
              itemsPerPageSelection: shownRecords,
              resultPageNumberSelection: pageNumber,
              clickText: value.label,
            })

            toggleItemsPerPage('sort', value.value)
          }}
          style={{ fontWeight: '600', color: '#666666' }}
        />
      </Box>
    </Box>
  )
}
